export const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT;
export const PAYMENT_API_ENDPOINT = import.meta.env.VITE_PAYMENT_API_ENDPOINT;
